<template>
  <div id="more-info" class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="row-title">Start your free trial</div>
          <div class="row-subtitle">
            Join 5000+ fast-growing businesses that use Verloop.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="domain-search-holder">
            <form id="title-signup-form">
              <div :class="['input-group', isEmailValid()]">
                <div class="row">
                  <div class="col-md-4 col-md-offset-3">
                    <input
                      class="form-control"
                      v-model="email"
                      type="email"
                      name="email"
                      placeholder="Your work email"
                    />
                  </div>
                  <div class="col-md-3">
                    <input
                      type="submit"
                      name="submit"
                      value="Create Free Account"
                      @click="createAccount($event)"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "more-info",
  data: function() {
    return {
      email: "",
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  methods: {
    isEmailValid() {
      return this.email == ""
        ? ""
        : this.reg.test(this.email)
        ? "has-success"
        : "has-error";
    },
    createAccount(e) {
      e.preventDefault();
      if (this.isEmailValid() != "has-error") {
        window.location.href = `/app/signup/email?utm_source=above-footer&utm_medium=web-client&utm_campaign=direct-click&email=${this.email}`;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.form-control {
  height: 50px;
}
.input-group {
  width: 100%;
}
</style>
